import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

import Settings from '@material-ui/icons/Settings';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function SettingsButton(props: { openSettings: () => void }) {
  const classes = useStyles();

  return (
    <Tooltip title={'Settings'} onClick={() => props.openSettings()} placement="top" PopperProps={{ disablePortal: true }}>
      <Fab className={classes.fab} color="primary">
        <Settings />
      </Fab>
    </Tooltip>
  );
}
